(function ($) {$(function(){
    const containers = $('p > iframe');
    if (containers.length > 0) {
        containers.each(function () {
            const $this = $(this);
            $this.parent().addClass('youtube-container');
        });
    }
});}(_jQ3));

